import { render, staticRenderFns } from "./NewsSources.vue?vue&type=template&id=fa56b246&"
import script from "./NewsSources.vue?vue&type=script&lang=js&"
export * from "./NewsSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports